if (!customElements.get('brand-logos-filter')) {
  class BrandLogosFilter extends HTMLElement {
    constructor() {
      super();
      this.onItemClick = this.onItemClick.bind(this);
      this.onFacetUpdate = this.onFacetUpdate.bind(this);
      this.facetUpdateUnsubscriber = undefined;
    }

    connectedCallback() {
      this.addEventListener('click', this.onItemClick);

      if (window.FoxTheme && FoxTheme.pubsub) {
        this.facetUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
          this.onFacetUpdate
        );
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onItemClick);
      if (this.facetUpdateUnsubscriber) this.facetUpdateUnsubscriber();
    }

    getFacetForm() {
      return document.querySelector('form[is="facet-form"]');
    }

    // A logo can map to several brand filter values (e.g. "'47" and "47 Brand").
    // Liquid stores them in data-vendor-values, joined by "||".
    parseVendorValues(item) {
      return (item.dataset.vendorValues || '')
        .split('||')
        .map((value) => value.trim())
        .filter(Boolean);
    }

    onItemClick(event) {
      const link = event.target.closest('.brand-logos__item[data-vendor-param]');
      if (!link) return;

      const form = this.getFacetForm();
      if (!form) return; // No filtering on this page: let the plain href navigate.

      const paramName = link.dataset.vendorParam;
      const paramValues = this.parseVendorValues(link);
      if (!paramName || paramValues.length === 0) return;

      event.preventDefault();

      const url = new URL(window.location.href);
      // Drop every existing value for this filter (there may be several, if a
      // brand was already selected) so picking a new brand REPLACES it instead
      // of adding to it. Every other active filter/sort is left untouched.
      url.searchParams.delete(paramName);
      paramValues.forEach((value) => url.searchParams.append(paramName, value));
      url.searchParams.delete('page');
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));

      // Optimistic UI: reflect the selection immediately, the facetUpdate
      // handler below reconciles it with the server response right after.
      this.setActiveVendor(paramName, paramValues);

      // scroll: false - this row sits above the grid already, no need to jump to it.
      form.renderSection(url.toString(), event, { scroll: false });
    }

    setActiveVendor(paramName, paramValues) {
      const wanted = paramValues.slice().sort().join('||');
      this.querySelectorAll('.brand-logos__item[data-vendor-param]').forEach((item) => {
        if (item.dataset.vendorParam !== paramName) return;
        const values = this.parseVendorValues(item);
        const active = values.length > 0 && values.slice().sort().join('||') === wanted;
        item.classList.toggle('is-active', active);
        if (active) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }

    onFacetUpdate(data) {
      if (!data || !data.responseText) return;

      const parsedHTML = new DOMParser().parseFromString(data.responseText, 'text/html');
      const updatedItems = Array.from(parsedHTML.querySelectorAll('.brand-logos__item[data-vendor-values]'));

      this.querySelectorAll('.brand-logos__item[data-vendor-values]').forEach((item) => {
        const updated = updatedItems.find(
          (candidate) =>
            candidate.dataset.vendorParam === item.dataset.vendorParam &&
            candidate.dataset.vendorValues === item.dataset.vendorValues
        );
        if (!updated) return;

        item.classList.toggle('is-active', updated.classList.contains('is-active'));
        item.href = updated.getAttribute('href');

        if (updated.hasAttribute('aria-current')) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('brand-logos-filter', BrandLogosFilter);
}
